export default "__VITE_ASSET__BbJ$E6ko__"